//React Components and Hooks
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
//Material UI Components
import { makeStyles } from "@mui/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React from "react";
import { useNavigate } from "react-router-dom";

//Custom Components
//Styles
//const useStyles = makeStyles((theme) => ()

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    "& label.Mui-focused": {
      color: theme.palette.secondary.main,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette.secondary.main,
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: theme.palette.secondary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.secondary.main,
      },
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const ReportResults = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <Paper>
      <Box sx={{ width: '100%' }}>
        <AppBar
          position="static"
          color="primary"
          style={{ marginBottom: "2rem" }}
        >
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Report Results
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
    </Paper>
  );
};

export default ReportResults;
